import { styled } from '../../../../stitches.config';
import { Card } from '../../..';

export const RuleInputContainer = styled('div', {
  flex: 1,
});

export const RuleContainer = styled(Card, {
  display: 'flex',
  alignItems: 'center',
  gap: '$4',
  padding: '$3 $4',
  width: '100%',
  fontSize: '$1',
});
